import createSagaMiddleware from "redux-saga";
import { combineReducer } from "./common/store/combinedReducer";
import { configureStore } from "@reduxjs/toolkit";
import { sagas } from "./common/store/saga";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: combineReducer,
  middleware: [sagaMiddleware],
});

sagaMiddleware.run(sagas);

// Test helper: creates an isolated store instance without starting sagas
export const createTestStore = () =>
  configureStore({
    reducer: combineReducer,
    middleware: [],
  });